// TermsOfService.js
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';
import TermsOfService from '../component/TermsOfService.jsx';

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
  };
};

export default connect(null, mapDispatchToProps)(TermsOfService);
